import React, { useCallback, useEffect, useState } from "react";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import api from "../../../../../service";
import { useIntl } from "react-intl";

import { useHistory } from "react-router-dom";
import {
  Container,
  Title,
  SubTitle,
  SearchContainer,
  InputWrapper,
  IconWrapper,
  StyledInput,
  StyledSpan,
} from "../../style";
import {
  CollaboratorsTable,
  DeleteCollaboratorButton,
  DeleteCollaboratorWrapper,
  StyledButton,
  TopContent,
} from "./styles";
import { CustomButton } from "../styles";
import { useSelector } from "react-redux";
import ModalNewCollaborator from "../../../../../components/ModalNewCollaborator";
import { notification } from "antd";
import { NoData } from "../../../SelectEvent/styles";
import { AttentionIcon } from "../../Sales/components/Icons";
import { Nav } from "../../Sales/styles";
import GoBackButton from "../../../components/goBackButton";
import { FantasyNameAndContractBadge } from "../../../components/badges";

const formatDocumentSearch = (raw) => {
  if (/[a-zA-Z]/.test(raw)) return raw;

  const digits = raw.replace(/\D/g, "");
  if (!digits) return raw;

  if (digits.length <= 11) {
    // CPF (pessoa fisica) — formata progressivamente para casar tambem em
    // buscas parciais (ex.: "123456" -> "123.456").
    return digits
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  }

  // Fallback CNPJ (14 digitos) por robustez.
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
};

const StaffCredentialscollaboratorsList = () => {
  const intl = useIntl();
  const history = useHistory();
  const { token } = useSelector((state) => state.auth);
  const [selectedRows, setSelectedRows] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleDelete, setModalVisibleDelete] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const fantasyName = localStorage.getItem("serviceFantasyname");
  const serviceContractNumber = localStorage.getItem("serviceContractNumber");
  const opportunityId = localStorage.getItem("serviceOpportunityId");
  const serviceSystemUserId = localStorage.getItem("serviceSystemUserId");
  const [paginationInfo, setPaginationInfo] = useState(null);

  const handleGoBack = () => {
    history.push("/staff-access/services/credentials");
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleGoBack();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchData = useCallback(async () => {
    setLoadingTable(true);
    try {
      const result = await api.get(`/associate-collaborators`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: currentPage - 1,
          per_page: pageSize,
          search: searchTerm,
          userId: serviceSystemUserId,
          opportunity_id: opportunityId,
        },
      });
      const list = result.data?.associateCollaboratorListOutput || [];
      setEmployee(list);
      setPaginationInfo(result.data.paginationInfo);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + error.response?.data?.description,
        }),
      });
    } finally {
      setLoadingTable(false);
    }
  }, [currentPage, pageSize, searchTerm, serviceSystemUserId, token, intl]); // Organized dependencies

  const columns = [
    {
      title: intl.formatMessage({ id: "name" }),
      dataIndex: "name",
      key: "name",
      render: (text) => <span>{text}</span>,
      responsive: ["xs", "sm", "md", "lg", "xl"],
      width: "50%",
    },
    {
      title: intl.formatMessage({ id: "document" }),
      dataIndex: "document",
      key: "document",
      responsive: ["xs", "sm", "md", "lg", "xl"],
      width: "20%",
    },
    {
      title: intl.formatMessage({ id: "associated_credential" }),
      dataIndex: "hasCredential",
      key: "hasCredential",
      render: (hasCredential) =>
        hasCredential
          ? intl.formatMessage({ id: "yes" })
          : intl.formatMessage({ id: "no" }),
      responsive: ["xs", "sm", "md", "lg", "xl"],
      width: "25%",
    },
    {
      title: intl.formatMessage({ id: "edit" }),
      key: "editar",
      width: "5%",
      render: (_, record) => (
        <StyledButton
          icon={<FaRegEdit size={22} />}
          onClick={() => handleEdit(record.id)}
        />
      ),
    },
  ];

  const handleEdit = (id) => {
    setEditingId(id);
    setIsEditing(true);
    setModalVisible(true);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize, searchTerm]);

  const handleDelete = useCallback(async () => {
    setLoadingTable(true);
    const ids = selectedRows.map((row) => row.id);

    try {
      const response = await api.delete(
        `/associate-collaborators/delete-multiple?userId=${serviceSystemUserId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
          data: ids,
        }
      );

      if (response.status === 200) {
        fetchData();
        setSelectedRows([]);
        notification.success({
          message: intl.formatMessage({
            id: "success",
          }),
          description: intl.formatMessage({
            id: "success.collaborator_deletion",
          }),
        });
      }
    } catch (error) {
      notification.error({
        message: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "api.error." + error.response?.data?.description,
        }),
      });
    } finally {
      setLoadingTable(false);
      setModalVisibleDelete(false);
    }
  }, [selectedRows, fetchData]);

  return (
    <div style={{ overflowY: "auto", height: "100vh" }}>
      <ModalNewCollaborator
        modalVisibleDelete={modalVisibleDelete}
        setModalVisible={setModalVisible}
        visible={modalVisible}
        editingId={editingId}
        setEditingId={setEditingId}
        setIsEditing={setIsEditing}
        isEditing={isEditing}
        selectedRows={selectedRows}
        setIsModalDeleteVisible={setModalVisibleDelete}
        handleDelete={handleDelete}
        fetchData={fetchData}
        isServiceProvider={
          localStorage.getItem("serviceRoleType") === "SERVICE_PROVIDER"
        }
      />

      <Container>
        <Nav>
          <GoBackButton
            noPosition
            href={"/staff-access/services/credentials"}
            intlId="goback"
          />

          <FantasyNameAndContractBadge
            fantasyname={fantasyName}
            contractNumber={serviceContractNumber}
          />
        </Nav>
        <TopContent>
          <div style={{ display: "flex", alignItems: "center" }}>
            <SubTitle style={{ paddingTop: "5px" }}>
              {intl.formatMessage({ id: "credentials" })} {" / "}
            </SubTitle>{" "}
            <Title style={{ paddingLeft: "5px" }}>
              {" "}
              {intl.formatMessage({ id: "list_of_Contributors" })}
            </Title>
          </div>
          <CustomButton onClick={() => setModalVisible(true)}>
            {intl.formatMessage({ id: "new_collaborator" })}
          </CustomButton>
        </TopContent>
        <SearchContainer>
          <InputWrapper>
            <IconWrapper>
              <SearchOutlined />
            </IconWrapper>
            <StyledInput
              style={{ paddingLeft: "30px" }}
              placeholder={intl.formatMessage({
                id: "search",
              })}
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(formatDocumentSearch(e.target.value))
              }
            />
          </InputWrapper>
        </SearchContainer>
        <DeleteCollaboratorWrapper>
          <StyledSpan>
            {selectedRows.length === 0
              ? intl.formatMessage({ id: "select_collaborator_to_delete" })
              : intl.formatMessage({ id: "select_collaborators" })}{" "}
            {selectedRows.length > 0 && <strong>{selectedRows.length}</strong>}
          </StyledSpan>
          <DeleteCollaboratorButton
            onClick={() => setModalVisibleDelete(true)}
            disabled={selectedRows.length === 0}
            style={{
              color:
                selectedRows.length > 0
                  ? "rgba(185, 28, 28, 1)"
                  : "rgba(194, 194, 204, 1)",
              background:
                selectedRows.length > 0
                  ? "rgba(254, 226, 226, 1)"
                  : "rgba(241, 245, 249, 1)",
            }}
          >
            <FaRegTrashAlt />
          </DeleteCollaboratorButton>
        </DeleteCollaboratorWrapper>

        <CollaboratorsTable
          rowKey="id"
          loading={loadingTable}
          locale={{ emptyText: <NoDataComponent /> }}
          rowSelection={{
            selectedRowKeys: selectedRows.map((row) => row.id),
            onChange: (_, selectedRows) =>
              setSelectedRows(
                selectedRows.map(({ id, name }) => ({ id, name }))
              ),
          }}
          columns={columns}
          dataSource={employee}
          pagination={{
            current: paginationInfo?.pageNumber + 1 || 1,
            pageSize: paginationInfo?.maxSize || 10,
            total: paginationInfo?.totalElements || 0,
            showSizeChanger: true,
            pageSizeOptions: ["10", "15", "20", "25", "30"],
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPageSize(pageSize);
            },
            showTotal: (total, range) =>
              `${intl.formatMessage({ id: "displaying" })} ${range[0]} - ${
                range[1]
              } ${intl.formatMessage({
                id: "of",
              })} ${total}`,
            locale: { items_per_page: "" },
            showLessItems: true,
            showQuickJumper: false,
          }}
        />
      </Container>
    </div>
  );
};

export default StaffCredentialscollaboratorsList;

function NoDataComponent() {
  const intl = useIntl();
  return (
    <NoData>
      <AttentionIcon />
      <p>{intl.formatMessage({ id: "nothing_here_yet" })}</p>
    </NoData>
  );
}
